import { IntelligenceModule } from 'utils/i18n/TModules';

// NOTE: the module is registered in all four UI locales per `conventions/i18n.md § Checklist`, but
// de/fr/it currently re-export the EN catalogue — the copy is pending translation, not absent, so a
// LANGUAGE_SELECTOR-on tenant still resolves every key through this module. PLA-8815.

// Translation Keys
export const CustomerInsightsKey = `CustomerInsights`;
export const OverwatchKey = `Overwatch`;

// Translation Paths
export const TCustomerInsights = `${IntelligenceModule}:${CustomerInsightsKey}`;
export const TOverwatch = `${IntelligenceModule}:${OverwatchKey}`;
